<script setup>
import { computed } from 'vue';
import ChannelIcon from 'dashboard/components-next/icon/ChannelIcon.vue';

const props = defineProps({
  inbox: {
    type: Object,
    default: () => {},
  },
});

const INBOX_COLOR_MAP = {
  'Channel::Whatsapp': { bg: '#dcfce7', text: '#15803d', icon: '#16a34a' },
  'Channel::TwilioSms': { bg: '#dcfce7', text: '#15803d', icon: '#16a34a' },
  'Channel::FacebookPage': { bg: '#dbeafe', text: '#1d4ed8', icon: '#2563eb' },
  'Channel::Instagram': { bg: '#fce7f3', text: '#be185d', icon: '#db2777' },
  'Channel::Telegram': { bg: '#e0f2fe', text: '#0369a1', icon: '#0284c7' },
  'Channel::Email': { bg: '#fef3c7', text: '#b45309', icon: '#d97706' },
  'Channel::WebWidget': { bg: '#e0e7ff', text: '#4338ca', icon: '#4f46e5' },
  'Channel::Api': { bg: '#ede9fe', text: '#6d28d9', icon: '#7c3aed' },
  'Channel::Sms': { bg: '#ccfbf1', text: '#0f766e', icon: '#0d9488' },
  'Channel::Line': { bg: '#d1fae5', text: '#047857', icon: '#059669' },
  'Channel::TwitterProfile': {
    bg: '#f1f5f9',
    text: '#334155',
    icon: '#475569',
  },
  'Channel::Tiktok': { bg: '#ffe4e6', text: '#be123c', icon: '#e11d48' },
};

const DEFAULT_COLORS = { bg: '#f1f5f9', text: '#64748b', icon: '#64748b' };

const customColor = computed(() => props.inbox?.color);

const colors = computed(() => {
  if (customColor.value) {
    return {
      bg: `${customColor.value}20`,
      text: customColor.value,
      icon: customColor.value,
    };
  }
  const type = props.inbox?.channel_type;
  if (type === 'Channel::TwilioSms' && props.inbox?.medium === 'whatsapp') {
    return INBOX_COLOR_MAP['Channel::Whatsapp'];
  }
  return INBOX_COLOR_MAP[type] || DEFAULT_COLORS;
});
</script>

<template>
  <div
    :title="inbox.name"
    class="flex items-center gap-0.5 min-w-0 rounded px-1 py-0.5"
  >
    <ChannelIcon
      :inbox="inbox"
      class="size-3.5 flex-shrink-0"
      :style="{ color: colors.icon }"
    />
    <span
      class="truncate text-xxs font-medium leading-3"
      :style="{ color: colors.text }"
    >
      {{ inbox.name }}
    </span>
  </div>
</template>
